import { stripEmoji } from './string';

// Fallback when sanitizing leaves nothing usable (e.g. a name that is entirely
// emoji), so the backend never receives a blank filename.
const FALLBACK_FILENAME = 'untitled';

// Strips characters the backend rejects (emoji + pictographic symbols such as
// ®, ©, ™) from a filename before upload.
export const sanitizeFilename = (name: string): string => {
  const sanitized = stripEmoji(name);
  return sanitized.trim() === '' ? FALLBACK_FILENAME : sanitized;
};
